import { Media } from '@teamfoster/sdk/image';
import { Button } from '@teamfoster/sdk/button';
import { LandingPageHeaderItem } from 'src/app/landing-pages/models/landing-page-header-item.model';

export interface Header {
  title: string;
  type: HeaderType;
  items: LandingPageHeaderItem[];
  subtitle: string | null;
  intro: string | null;
  media: Media | null;
  buttons: Button[];
}

export enum HeaderType {
  default = 0,
  slider = 1,
  imageEffect = 2,
}
